
import React from "react";
import SearchFeed from "./component/SearchFeed"
import { BrowserRouter,Routes,Route } from "react-router-dom";
import { Box } from "@mui/material";
import VideoDetail from "./component/VideoDetail";
import Feed from "./component/Feed";
import ChannelDetail from "./component/ChannelDetail";
import Navbar from "./component/Navbar";




function App() {
  return (
  <BrowserRouter>
  <Box sx={{backgroundColor:"#000"}}>
  <Navbar/>
  <Routes>
    <Route path="/" exact element={<Feed/>}/>
    <Route path="/video/:id" exact element={<VideoDetail/>}/>
    <Route path="/channel/:id" exact element={<ChannelDetail/>}/>
    <Route path="/search/:searchTerm" exact element={<SearchFeed/>}/>
  </Routes>
  </Box>
  </BrowserRouter>
  );
}

export default App;
